module.exports = __webpack_public_path__ + "static/vw_com_en-a74f08fcde6d1dfc7b7b8532a1b82af0.svg";